import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>Credits: Coding Addict, Dev Ed &copy; Andreas Motsie 2020</p>
    </footer>
  );
}
